export class BaseException extends Error {
    public static DEFAULT_ERROR_MSG = "Entschuldigung, es ist ein Fehler aufgetreten.";

    public constructor(message?: string) {
        super(message ?? BaseException.DEFAULT_ERROR_MSG);

        Object.setPrototypeOf(this, BaseException.prototype);
    }
}
